import { createFileRoute } from '@tanstack/react-router'
import { HubPage } from '~/components/routes/logistics/hub-page'
import { LogisticsRecordRoute } from '~/components/routes/logistics/logistics-record-page'
import { LOGISTICS_HUB_ADD } from '~/components/routes/logistics/tabs'
import { withRoutePermissions } from '~/utils/rbac'
import { logisticsSearchSchema } from '../-search-schema'

export const Route = createFileRoute('/_authenticated/logistics/hubs/new')({
  staticData: {
    permission: LOGISTICS_HUB_ADD,
  },
  component: NewHubRoute,
  validateSearch: logisticsSearchSchema,
})
withRoutePermissions(Route)

function NewHubRoute() {
  return (
    <LogisticsRecordRoute tab="hubs" search={Route.useSearch()} permission={LOGISTICS_HUB_ADD}>
      {(search) => <HubPage hubId={null} search={search} />}
    </LogisticsRecordRoute>
  )
}
